<template >
    <q-card class="splash">
        <div class="text-h4 text-center q-mb-md text-uppercase text-white bg-black row items-center justify-center q-pa-md" color="primary">
            Marine Mapping Tool | 
            <span class="text-h6">Northeast & Mid-Atlantic <span class="text-lowercase">v</span>2.0</span>
        </div>
        <div class="q-ma-md">
            <div>
                <span class="text-bold">Welcome to the Northeast Marine Mapping Tool.</span> This tool was designed to quantitatively assess and review marine life and habitat data from trusted public sources.  It summarizes data for a site, provides context to the numbers, and connects information based on the best available science.
            </div>

            <div class="row q-mb-md q-mt-sm justify-center" v-if="Screen.gt.xs">
                <div class="col-2"></div> <!-- temp spacer until video tutorials ready -->
                <div class="col q-mr-sm q-mt-sm box-background">
                    <div class="row items-center q-pa-sm">
                        <div class="col-5 text-bold text-secondary">Want to learn more about the tool?</div>
                        <div class="col-2"><q-icon color="secondary" name="arrow_right" size="md"/></div>
                        <div class="col-5">Review the information on our <a href="https://maps.tnc.org/marinemap/" target="_blank" class="myLink">webpage</a></div>
                    </div>
                </div>
                <!-- <div class="col q-mr-sm q-mt-sm box-background">
                    <div class="row items-center q-pa-sm q-pt-md">
                        <div class="col-5 text-bold text-secondary">Problems getting started?</div>
                        <div class="col-2"><q-icon color="secondary" name="arrow_right" size="md"/></div>
                        <div class="col-5">View these short <a href="https://crcs.tnc.org/" target="_blank" class="myLink">video tutorials</a></div>
                    </div>
                </div> -->
                <div class="col q-mr-sm q-mt-sm box-background">
                    <div class="row items-center q-pa-sm">
                        <div class="col-5 text-bold text-secondary">Questions?</div>
                        <div class="col-2"><q-icon color="secondary" name="arrow_right" size="md"/></div>
                        <div class="col-5"><a href="https://forms.office.com/r/bNPTEik3id" target="_blank" class="myLink">Contact us!</a></div>
                    </div>
                </div>
                <div class="col-2"></div><!-- temp spacer until video tutorials ready -->
            </div>
            <div v-if="Screen.lt.sm">
                <div class="text-h5 text-center text-white text-uppercase q-pa-sm q-mt-md border secondary-background" outline >
                    <div class="text-body1">The Marine Mapping Tool is not designed for small screens.
                        Please come back using a larger device.</div>
                        <a href="https://crcs.tnc.org/">
                        <q-btn class="q-ma-sm" label="Learn More" outline color="primary"
                            aria-label="Exit to Center for Resilient Conservation Science page" />
                    </a>
                </div>
            </div>

            
            <div class="row items-center" v-if="Screen.gt.xs">
                <div class="col-6 text-h5 text-uppercase pointer q-pa-sm q-mt-md"
                    :style="{ 'backgroundColor': '#ededed' }" @click="openSE()">
                    <div class="text-body2">Looking for information from North Carolina to Florida? Visit the</div>
                    <span class="text-bold">SE Marine Mapping Tool</span>
                </div>
                <div class="col-6">
                    <div class="text-h5 text-white text-uppercase q-pa-sm q-mt-md q-pl-md pointer border secondary-background"
                        :style="{'width':'100%' }" @click="$emit('enter')" aria-label="Enter tool">
                        <div class="text-body1">Enter the</div>
                        NE Marine Mapping Tool >>
                    </div>
                </div>
            </div>

            <q-separator class="q-mt-md"/>

            <div class="row q-pa-sm items-center">
                <div class="col text-caption">Designed and developed by</div>
                <div class="col"><a href='https://crcs.tnc.org' target='_blank' aria-label="Go to CRCS webpage"><q-img :src="crcsLogo" width="75%"  alt="CRCS Logo"></q-img></a></div>
                <q-separator vertical class="q-mr-md" :style="{'min-height' : '50px'}" />
                <div class="col"><a href='https://nature.org' target='_blank' aria-label="Go to The Nature Conservancy webpage"><q-img :src="tncLogo" width="75%"  alt="The Nature Conservancy Logo"></q-img></a></div>
                <div class="col text-caption sm-line-height">With the help of a steering committee of users and experts.  Funded by:</div>
                <div class="col"><q-img :src="pasculano" width="75%"  alt="Pasculano Familiy Foundation"></q-img></div>
                <div class="col"><a href='https://www.moore.org/' target='_blank' aria-label="Go to CRCS webpage"><q-img :src="moore" width="75%"  alt="Moore Foundation Logo"></q-img></a></div>
                <div class="col"><a href='https://www.deq.virginia.gov/our-programs/coastal-zone-management/' target='_blank' aria-label="Go to CRCS webpage"><q-img :src="vaczm" width="50%"  alt="Virginia Coastal Zone Management Logo"></q-img></a></div>
            </div>

            <q-separator class="q-ma-sm q-mt-lg"/>
            <div class="legal q-pl-sm q-pr-sm">
                This is version {{ appVersion }} of the tool, released {{  releaseDate }} (<a href="log.txt" target="_blank" class="myLink">Change Log</a>). 
                <span class='text-underline'>Please cite as: Marine Mapping Tool, Northeast and Mid-Atlantic [Web application, version {{ appVersion }}.]. 2025. Design and content by M.M. Ribera. Web application by E.H. Martin. Conceptual guidance by M. Anderson, T. Jedele, and C. McGuire. The Nature Conservancy, Center for Resilient Conservation Science. https://www.maps.tnc.org/marinemap/ne</span> 
            </div>
            <q-separator class="q-ma-sm"/>
            <div class="legal q-pl-sm q-pr-sm">This tool is intended to provide screening-level information to help inform conservation
                planning actions. The Nature Conservancy (TNC) created this data set from the manipulation, analysis, and/or
                synthesis of publicly available data sources. It is not intended to replace the necessary due diligence
                required to gather pertinent site-specific information. Additional 
                <a class="myLink"
                    href="https://tnc.app.box.com/s/bu8jfr4c64mi471o1j6jcbi04k8up0x6" target="_blank">
                    Terms of Use
                </a> and data limitations when working with TNC data apply. </div>
            <div class="legal justify-center q-pl-sm q-pr-sm">By entering the site, you agree to the terms outlined in the 
                <a class="myLink"
                    href="https://www.nature.org/en-us/about-us/who-we-are/accountability/terms-of-use/" target="_blank">
                    Legal Disclosures
                </a> and 
                <a class="myLink"
                    href="https://www.nature.org/en-us/about-us/who-we-are/accountability/privacy-policy/"
                    target="_blank">Privacy Statements
                </a> of The Nature Conservancy
            </div>
            <div class="row justify-center">
                <div class="text-body2 q-pb-md" v-if="$q.dark.isActive">NOTE: Your system is currently in dark mode. You may
                    continue to use dark mode, but the colors on this site are optimized for light mode.</div>
            </div>
        </div>
    </q-card>
</template>
<script setup>

import {  onMounted, computed } from 'vue'
import { Screen } from 'quasar'
import tncLogo from '../assets/TNCLogoPrimary_RGB.png'
import crcsLogo from '../assets/crcs_logo_square_color_withtext.png'
import pasculano from '../assets/Pasculano_logo.png'
import vaczm from '../assets/va_czm.png'
import moore from '../assets/moore_logo.png'
import { useMapItems } from "../composables/useMapItems"
const { appVersion, releaseDate } = useMapItems()

const openSE = () =>{
    window.open("https://www.maps.tnc.org/marinemap/se", "_self")
}

onMounted(() => {

});
</script>
<style scoped>
.legal{
    font-size: x-small;
    color: #808080
}
.splash{
  min-width: 80%;
}
.box-background {
    background-color: #F1FDFC;
    border: 1px solid #1D8177;
}
.secondary-background{
    background-color: #1D8177;
}
.sm-line-height{
    line-height:1.2
}
</style>